import AuthMixin from '@/components/mixins/auth-mixin'
import { useZendeskMessenger } from '@base-shared/composables/use-zendesk-messenger'
import { useMixpanel } from '@base-shared/composables/use-mixpanel'

export default {
  name: 'virtualPlayerIframe',
  inject: [
    '$currentUser',
    '$utils',
    '$api',
    '$apiError'
  ],
  components: {
  },
  props: {
    dataProp: {
      type: String,
      default () { return '' }
    }
  },
  watch: {
    dataProp (val) {
      this.dataPropVal = val
    },
    '$route.params' (newVal, prevVal) {
      this.setDefaultData()
    }
  },
  mixins: [AuthMixin],
  data () {
    return {
      dataPropVal: this.dataProp,
      serialNumber: null,
      player: null
    }
  },
  methods: {
    emitEvent (action, data) {
      if (action !== null || action.length > 0) {
        this.$emit('structure-layout-change', { action, payload: { data } })
      }
    },
    setDefaultData () {
      const serialNumber = this.$route.params && this.$route.params.serialNumber
      this.getPlayerDetails({ serialNumber })
    },
    filterPlayerData (playerSrc) {
      const player = this.$utils.clone(playerSrc)
      player._edit = {
        uid: 'virtualPlayerPreview',
        iFrameStatus: 'default'
      }

      const newPreview = this.$utils.clone(player.preview)
      if (newPreview.live) {
        newPreview.url = newPreview.live
      }

      player.preview = newPreview
      player._edit.preview = newPreview

      return player
    },
    getPlayerDetails (params) {
      if (!params.serialNumber) return

      const getPlayer = () => {
        this.$utils.mainLoader(true)
        const requestParams = {
          width: 600,
          use_qsa: 1
        }

        this.$api.get(`${CONFIG.API_BASE_URL}/player/${params.serialNumber}`, { params: requestParams })
          .then(response => {
            this.player = this.filterPlayerData(response.data)
            this.$utils.mainLoader(false)
          })
          .catch((error) => {
            this.$apiError.handleUnauthorizedError(error, { originalRequest: () => { getPlayer() } })
          })
      }
      getPlayer()
    },
    postMessageToSVG (msg) {
      if ($('#virtualPlayerPreviewIframe').length) $('#virtualPlayerPreviewIframe')[0].contentWindow.postMessage(msg, '*')
    },
    handleSVGOnLoad () {
      if (this.$currentUser.getJWToken()) {
        this.postMessageToSVG({
          type: 'iframeOnLoad',
          projectOptions: {
            token: this.$currentUser.getJWToken()
          }
        })
      }
    },
    addMessageListener () {
      if (!this.handleSVGMessageEventListenerFunction) {
        this.handleSVGMessageEventListenerFunction = this.handleSVGMessage.bind(this)
        window.addEventListener('message', this.handleSVGMessageEventListenerFunction)
      }
    },
    handleSVGMessage (event) {
    },
    removeMessageListener () {
      if (this.handleSVGMessageEventListenerFunction) {
        window.removeEventListener('message', this.handleSVGMessageEventListenerFunction)
        this.handleSVGMessageEventListenerFunction = null
      }
    }
  },
  beforeUnmount () {
    useZendeskMessenger().toggleVisibility(true)
    this.removeMessageListener()
  },
  mounted () {
    this.addMessageListener()
    this.isAuthenticated({
      callback: () => {
        useMixpanel().track('Virtual Player Iframe')
        this.setDefaultData()
        useZendeskMessenger().toggleVisibility(false)
      }
    })
  }
}
